
<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 315 315" width="100%" height="100%" style="enable-background:new 0 0 350 350;" xml:space="preserve">

<g transform="translate(-5 5)">
	<g opacity="0.15">
		
			<image style="overflow:visible;" width="350" height="90" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAV8AAABbCAYAAADUU4YjAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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" transform="matrix(1 0 0 1 0 230.9937)">
		</image>
	</g>
	<g>
		<g>
			<rect x="100.79" y="19.86" fill="#3B4E9A" width="182.8" height="256.71"/>
			<g>
				<rect x="107.21" y="26.97" fill="#93A4D4" width="169.95" height="244.84"/>
				<g>
					<rect x="124.72" y="57.01" fill="#3B4E9A" width="138.75" height="7.94"/>
					<rect x="124.72" y="105.45" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="114.01" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="122.57" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="131.14" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="139.7" fill="#3B4E9A" width="138.75" height="3.64"/>
					<rect x="124.72" y="148.27" fill="#3B4E9A" width="138.75" height="3.64"/>
					<g>
						<circle fill="#3B4E9A" cx="154.64" cy="198.01" r="10.71"/>
						<path fill="#3B4E9A" d="M210.17,208.3c-0.03,0-0.06,0-0.09-0.01c-0.29-0.05-0.49-0.33-0.44-0.62c0.1-0.59,2.54-14.44,10.22-19.15
							c0.55-0.33,0.89-0.16,1.05-0.03c0.67,0.58,0.16,2.05-2.15,7.59c-0.92,2.21-2.01,4.83-2.46,6.42c0.82-1.07,2.04-2.91,3.02-4.37
							c3.04-4.56,3.63-5.31,4.22-5.31c0.22,0,0.42,0.1,0.54,0.28c0.32,0.46,0.08,1.24-0.76,3.51c-0.32,0.87-0.81,2.21-0.96,2.92
							c0.44-0.39,1.08-1.23,1.46-1.73c1.05-1.37,1.59-2.02,2.21-1.93c0.13,0.02,0.45,0.11,0.61,0.54c0.06,0.18,0.09,0.37,0.12,0.59
							c0.08,0.55,0.18,1.17,0.84,1.54c1.33,0.75,5.18,0.71,15.91-3.77c0.27-0.11,0.59,0.02,0.7,0.29c0.11,0.27-0.02,0.59-0.29,0.7
							c-9.06,3.78-14.58,4.99-16.85,3.71c-1.11-0.62-1.27-1.67-1.37-2.3c-0.31,0.32-0.73,0.87-1.04,1.28
							c-1.16,1.51-1.93,2.42-2.7,2.36c-0.24-0.02-0.44-0.14-0.57-0.34c-0.37-0.59-0.01-1.74,0.91-4.23c0.15-0.4,0.32-0.86,0.46-1.28
							c-0.74,1.02-1.75,2.53-2.57,3.76c-3.4,5.11-4.02,5.85-4.7,5.66c-0.11-0.03-0.45-0.16-0.48-0.66c-0.07-1.2,1.05-3.97,2.75-8.07
							c0.87-2.08,2-4.81,2.28-6.01c-6.99,4.69-9.33,18.05-9.35,18.18C210.65,208.12,210.42,208.3,210.17,208.3z M222.02,199.77
							L222.02,199.77L222.02,199.77z"/>
					</g>
				</g>
			</g>
			<path fill="#FAD333" d="M232.23,15.7h-21.55c0.48-1.28,0.75-2.66,0.75-4.1c0-6.41-5.19-11.6-11.6-11.6c-6.41,0-11.6,5.19-11.6,11.6
				c0,1.45,0.27,2.83,0.75,4.1h-21.55c-1.73,0-3.14,1.41-3.14,3.14v8.71c0,1.73,1.41,3.14,3.14,3.14h64.81
				c1.73,0,3.14-1.41,3.14-3.14v-8.71C235.37,17.11,233.97,15.7,232.23,15.7z M199.83,15.88c-2.37,0-4.28-1.92-4.28-4.28
				c0-2.37,1.92-4.28,4.28-4.28c2.36,0,4.28,1.92,4.28,4.28C204.11,13.96,202.19,15.88,199.83,15.88z"/>
			<path fill="#F9B925" d="M167.43,30.69h64.81c1.73,0,3.14-1.41,3.14-3.14v-8.71L167.43,30.69z"/>
		</g>
		<g>
			<path fill="#E49863" d="M169.96,95.37c-1.24,2.51-3.24,5.36-5.08,5.93c-2.09,0.64-3.05,1.76-3.05,1.76l-1.52-1.11l-1.81-1.32
				c0,0,0.07-0.21,0.2-0.55c0.13-0.34,0.32-0.81,0.58-1.32c0,0,0.67-0.7,0.41-1.69c-0.26-0.99-0.04-2.46,0.68-3.3
				c0.71-0.83,1.54-2.99,1.91-2.88c0.89,0.25-0.78,3.15-0.45,3.76c0.3,0.55,0.75,0.42,0.84,0.39c0.01,0,0.01,0,0.02-0.01
				c2.65-0.85,6.34-6.53,7.62-5.58C170.76,89.8,170.49,94.3,169.96,95.37z"/>
			<path fill="#284663" d="M118.4,89.12c0,0,12.35,18.91,17.9,24.47l22.52-14.73c0,0,3.07,1.15,4.24,4.37c0,0-14.71,25.84-27.66,26.18
				c-12.95,0.34-28.99-33.84-28.99-33.84L118.4,89.12z"/>
			<g>
				<path fill="#1D1D1B" d="M74.25,276.57h-9.37c-1.18-0.64-2.23-2.11-2.56-4.29c-0.46-3.02-3.84-4.67-4.57-7.14
					c-0.73-2.47,3.02-5.94,3.02-5.94l0.63-0.81l0.65-0.84l6.22,1.46c0,0,0.15,1.48,0.25,3.37c0.07,1.36,0.1,2.93,0.03,4.31
					c-0.18,3.29,0.92,6.84,3.85,7.48C74.54,274.65,74.44,275.93,74.25,276.57z"/>
				<path fill="#1D1D1B" d="M128.64,276.57H107.2c-1.03-1.26-0.65-5.9-0.49-7.42c0.03-0.31,0.05-0.48,0.05-0.48s7.32-5.85,8.32-1.37
					c0.03,0.14,0.07,0.28,0.11,0.41c1.27,4.19,6.95,6.1,10.23,6.63C127.56,274.69,128.35,275.8,128.64,276.57z"/>
				<path fill="#63B347" d="M124.55,156.93c0,0-1.11,13.87-2.42,30.53c-1.78,22.64-3.91,50.45-4.12,55.72
					c-0.37,9.15-1.83,23.78-1.83,23.78s-3.47,3.48-10.43,2.01c0,0-6.2-20.89-7.97-42.99c-0.03-0.36-0.05-0.73-0.08-1.09
					c-1.65-22.5-4.21-69.88-4.21-69.88L124.55,156.93z"/>
				<path opacity="0.5" fill="#3E954E" d="M124.55,156.93c0,0-1.11,13.87-2.42,30.53l-24.35,38.52c-0.03-0.36-0.05-0.73-0.08-1.09
					c-1.65-22.5-4.21-69.88-4.21-69.88L124.55,156.93z"/>
				<path fill="#63B347" d="M119.48,158.58c0,0-20.03,50.22-33.2,73.82c-13.17,23.6-17.29,30.19-17.29,30.19s-7.55-3.02-8.23-5.08
					c0,0,5.04-45.56,13.86-56.67c4.98-6.28,10.84-25.11,11.11-31.69c0.27-6.59,1.78-19.62,1.78-19.62L119.48,158.58z"/>
			</g>
			<path fill="#E49863" d="M114.49,85.37c-7.83,2.47-21.37-4.2-21.37-4.2s7.22-5.42,6.84-16.68l6.05,4.88l4.11,3.31
				c0,0-0.02,1.95-0.47,5.38c-0.12,0.9-0.27,1.9-0.45,3C112.56,82.91,114.49,85.37,114.49,85.37z"/>
			<path fill="#D89060" d="M110.12,72.68c0,0-0.02,1.95-0.47,5.38c-4.56-0.78-9.72-8.14-9.72-8.14c2.32-0.67,4.35-0.79,6.08-0.54
				L110.12,72.68z"/>
			<path fill="#E49863" d="M112.52,72.5c0,0-12.93,2.15-14.14-5.92c-1.21-8.07-3.7-13.23,4.5-14.95c8.2-1.71,10.28,1.13,11.34,3.72
				C115.27,57.95,115.85,71.73,112.52,72.5z"/>
			<path fill="#3B4E9A" d="M125.42,158.08c-0.24,0.2-0.51,0.31-0.82,0.31c-2.94-0.04-11.51,1.59-18.76,0.85
				c-6.11-0.59-11.53-2.4-17.34-5c-0.77-0.35-2.55-1.29-2.51-2.16c0.03-0.94,0.12-2.31,0.24-4.04c0.41-6,1.13-16.32,0.43-28.22
				c-0.13-2.22-0.19-4.42-0.2-6.58c-0.06-16.13,3.14-30.32,9.57-35.13c0.55-0.39,3.92,1.25,7.02,2.78c2.86,1.41,5.72,1.57,8.43,1.02
				l2.7,2.39c3.29,3.06,6.9,7.21,8.47,13.52c1.33,5.37,2.12,15.05,2.55,25.09c0.2,4.55,0.35,9.13,0.39,13.49v0.16
				c0.04,0.43,0.04,0.9,0.04,1.33C125.77,149.07,125.61,157.93,125.42,158.08z"/>
			<path fill="#233862" d="M86.22,148.04c0.41-6,1.13-16.32,0.43-28.22c-0.13-2.22-0.19-4.42-0.2-6.58c2.68-6.5,4.87-11.21,4.87-11.21
				h6.75C98.07,102.04,103.02,135.84,86.22,148.04z"/>
			<path fill="#3C3C3B" d="M98.36,65.8c0,0,1.33-0.22,1.11-2.05c-0.21-1.83-0.21-4.22,1.27-3.77c1.49,0.44,1.56,1.63,2.17,0.94
				c0.61-0.69,0.62-3.62,5.04-3.83c4.42-0.2,6.22,1.34,8.27,0.43c2.06-0.9,2.16-4.02,2.16-4.02s-0.58,1.11-1.47,1.46
				c0,0,3.43-4.69-0.54-7.91c-3.97-3.22-8.02-1.11-10.32-0.97c-5.06,0.31-8.33,0.61-9.99,3.94C94.43,53.35,95.11,62.59,98.36,65.8z"
			/>
			<!--PEN-->
			<g>
				<path fill="#233862" d="M225.06,50.43l-12.15,7.51l-1.36-2.2l12.15-7.51c0.61-0.38,1.41-0.19,1.78,0.42l0,0
					C225.86,49.26,225.67,50.06,225.06,50.43z"/>
				<path fill="#3E954E" d="M94.96,119.19l3.26,7.86l-0.06,0.04l0.16,0.18l0.09,0.22l0.06-0.04l5.57,6.43
					c0,0,83.48-51.57,114.84-78.05c1-0.85,1.23-2.31,0.54-3.42l0,0c-0.69-1.12-2.1-1.57-3.3-1.05
					C178.41,67.57,94.96,119.19,94.96,119.19z"/>
				<path fill="#2A6332" d="M217.61,51.18c-0.14,0.48-0.42,0.92-0.82,1.26c-31.36,26.48-114.84,78.05-114.84,78.05l-4.41-5.08
					l0.68,1.64l-0.06,0.04l0.16,0.18l0.09,0.22l0.06-0.04l5.57,6.43c0,0,83.48-51.57,114.84-78.05c1-0.85,1.23-2.31,0.54-3.42
					C219.01,51.73,218.34,51.3,217.61,51.18z"/>
				<path fill="#284663" d="M16.94,182.09l14.45-8.93l-4.05-6.55l-14.45,8.93c-1.81,1.12-2.37,3.49-1.25,5.3l0,0
					C12.76,182.65,15.13,183.21,16.94,182.09z"/>
				<path fill="#3E954E" d="M106.35,134.59l-65.62,40.56c-4.92,3.04-11.36,1.52-14.4-3.4l0,0c-3.04-4.92-1.52-11.36,3.4-14.4
					l65.62-40.56c0.85-0.52,1.96-0.26,2.48,0.59l9.11,14.74C107.46,132.96,107.2,134.07,106.35,134.59z"/>
				<path fill="#2A6332" d="M25.45,169.97c0.23,0.61,0.53,1.21,0.88,1.79l0,0c3.04,4.92,9.49,6.44,14.4,3.4l65.62-40.56
					c0.85-0.52,1.11-1.63,0.59-2.48l-1.15-1.85l-67.15,41.51C34.31,174.45,28.78,173.58,25.45,169.97z"/>
				<path fill="#F1A34F" d="M86.21,119.98l-6.49,4.12c-0.65,2.25-2.48,4.61-5.16,6.31c-2.67,1.7-5.58,2.36-7.9,2l-38.75,24.65
					c-5.4,3.44-7,10.63-3.57,16.03l3.71,5.83c0.59,0.93,0.32,2.16-0.61,2.75c-0.93,0.59-2.16,0.32-2.75-0.61l-3.71-5.83
					c-4.61-7.26-2.47-16.91,4.79-21.53l58.29-37.07c0.93-0.59,2.16-0.32,2.75,0.61C87.41,118.16,87.13,119.39,86.21,119.98z"/>
				<polygon fill="#2A6332" points="105.93,133.09 105.79,130.26 97.85,117.41 109.02,129.94 "/>
			</g>
			<path fill="#E49863" d="M73.13,152.5c0.01-0.15,0.02-0.31,0.03-0.47c0.06-0.8,1.57-2.82,1.57-2.82l-3.79-1.97l-1.5,2.48
				c-2.27,1.8-2.31,1.84-1.89,5.29c0.36,2.99-1.6,3.03-1.55,5.17c0.05,2.14,2.8,1.09,2.8,1.09c4.27-2,4.62-3.01,4.49-5.05
				c0.4,0.57,0.86,0.91,1.24,0.66c0.34-0.22-0.34-1.1-0.63-3.12C73.85,153.45,73.49,152.94,73.13,152.5z"/>
			<path fill="#3B4E9A" d="M70.89,150.75c2.43,0.47,5.07,0.28,5.07,0.28s7.22-22.29,8.14-24.33c0.93-2.04,21.43-26.14,21.43-26.14
				l-8.54-21.38c0,0-22.18,37.05-24.43,42.25c-3.72,8.6-5.01,27.89-5.01,27.89S68.98,150.38,70.89,150.75z"/>
			<path fill="#E49863" d="M170.5,92.16c0,0,0.2-3.29-1.09-3.29c-1.29,0-7.89,8.52-7.89,8.52l0.53,1.83L170.5,92.16z"/>
		</g>
	</g>
	<g>
		<path fill="#43A643" d="M279.48,228.23c-21.44,0-38.92,17.43-39.05,38.92c-0.13,21.4,17.44,39.03,38.98,39.12
			c21.43,0.09,39.07-17.49,39.11-38.99C318.57,245.84,300.96,228.23,279.48,228.23z"/>
		<linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="257.8955" y1="267.2307" x2="301.0525" y2="267.2307">
			<stop  offset="0" style="stop-color:#FFFFFF"/>
			<stop  offset="1" style="stop-color:#F3F6FD"/>
		</linearGradient>
		<path fill="#FFFFFF" d="M291.66,251.65c-5.8,6.84-11.61,13.67-17.44,20.54c-2.33-2.52-4.61-5-6.9-7.47
			c-0.72-0.78-1.48-1.49-2.51-1.85c-2.18-0.76-4.59,0.09-5.96,2.12c-1.43,2.11-1.29,4.19,0.66,6.33c3.72,4.08,7.52,8.08,11.29,12.11
			c0.58,0.62,1.25,1.08,2.08,1.32c2.54,0.74,4.41-0.32,6-2.19c4.99-5.87,9.99-11.74,14.97-17.61c2.07-2.44,4.18-4.84,6.14-7.36
			c1.45-1.87,1.37-4.11,0.05-5.84C297.74,248.75,294.15,248.72,291.66,251.65z"/>
	</g>
</g>
</svg>
